import {
  getTaskList,
  pathCreateTask,
  pathDeleteTask,
  getTaskListDetail,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { taskActions } from "../reducers/task";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchTaskList = (id_task = 0) => {
  return (dispatch) => {
    return apiService
      .get(getTaskList(id_task))
      .then((response) => {
        id_task == 0
          ? dispatch(taskActions.fetchTaskList(response.data))
          : dispatch(taskActions.fetchTaskDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchTaskListDetails = (id_task = 0) => {
  return (dispatch) => {
    return apiService
      .get(getTaskListDetail(id_task))
      .then((response) => {
        dispatch(taskActions.fetchTaskListDetails(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchClearDetailTask = () => {
  return (dispatch) => {
    dispatch(taskActions.fetchTaskDetail([]));
  };
};

export const createNewTask = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateTask(), data)
      .then((response) => {
        // dispatch(countryActions.fetchCountryList(response.data));
        toast.success(t("taksListActions.created"), {
          theme: "colored",
        });
        navigate("/task-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewTask1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateTask(), data)
      .then((response) => {
        // dispatch(taskActions.fetchTaskList(response.data));
        toast.success(t("taksListActions.created"), {
          theme: "colored",
        });
        navigate("/task-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditTask = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateTask(), data)
      .then((response) => {
        // dispatch(taskActions.fetchTaskList(response.data));
        toast.success(t("taksListActions.updated"), {
          theme: "colored",
        });
        navigate("/task-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteTask = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteTask(id))
      .then((response) => {
        toast.success(t("taksListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchTaskList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
